/*
 * Copyright 2020 Thomer Gil [https://thomer.com/games/brickbreaker-js/]
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import * as ex from 'excalibur';
import { Game } from './game';
import { BB } from './globals';

function startBrickBreaker(
    nbricks: number,
    nballs: number,
    nrows: number,
    ballYSpeed: number,
    ballXSpeedSlow: number,
    ballXSpeedFast: number,
    paddleMove: number,
    level: number,
    infinite: boolean,
    paddleWidth: number,
    auto: boolean,
    nlives: number,
): void {
    BB.screenWidth = nbricks * window.BB.BRICK_WIDTH + window.BB.BRICK_HSPACE * (nbricks - 1);
    BB.screenHeight =
        window.BB.ABOVE_WALL_EMPTY_SPACE +
        nrows * window.BB.BRICK_HEIGHT +
        (nrows - 1) * window.BB.BRICK_VSPACE +
        window.BB.BELOW_WALL_EMPTY_SPACE +
        window.BB.PADDLE_HEIGHT +
        window.BB.BELOW_PADDLE_EMPTY_SPACE;

    BB.BALL_X_SPEED_FAST = ballXSpeedFast;
    BB.BALL_X_SPEED_SLOW = ballXSpeedSlow;
    BB.BALL_Y_SPEED = ballYSpeed;
    BB.LEVEL_START = level;
    BB.NBALLS = nballs;
    BB.NBRICKS = nbricks;
    BB.NLIVES = nlives;
    BB.NROWS = nrows;
    BB.PADDLE_MOVE = paddleMove;
    BB.PADDLE_WIDTH = paddleWidth;
    BB.LIVES_INFINITE = infinite;
    BB.PADDLE_AUTO = auto;

    BB.PADDLE_ZONES[BB.BALL_X_SPEED_SLOW] = [
        // bounce back
        [15, 'MULT', -1],

        // symmetric bounce
        [65, 'SET', BB.BALL_X_SPEED_SLOW],

        // accelerate to high speed
        [20, 'SET', BB.BALL_X_SPEED_FAST],
    ];

    BB.PADDLE_ZONES[BB.BALL_X_SPEED_FAST] = [
        // bounce back
        [15, 'MULT', -1],

        // dampen to low speed
        [50, 'SET', BB.BALL_X_SPEED_SLOW],

        // continue at high speed
        [35, 'SET', BB.BALL_X_SPEED_FAST],
    ];

    // create an asset loader
    const loader = new ex.Loader();
    const resources = {
        /* include resources here */
        //txPlayer: new ex.Texture("assets/tex/player.png")
    };

    // queue resources for loading
    for (const r in resources) {
        loader.addResource(resources[r]);
    }

    // uncomment loader after adding resources
    // NB: eslint errors
    // game.start(/* loader */).then(() => {});
    Game.Instance().start();
}

// to allow HTML file to reach into this code
// https://github.com/microsoft/TypeScript/issues/33128
export {};
declare global {
    interface Window {
        BB: typeof BB;
        startBrickBreaker: typeof startBrickBreaker;
    }
}
window.BB = BB;
window.startBrickBreaker = startBrickBreaker;
